import { useState } from 'react'
import { Loader2, Stethoscope } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { criarWorkspace } from '@/services/identity'

export default function OnboardingPage() {
  const { user, workspaces, refresh, loading, allowSelfSignup, isPlatformAdmin } = useAuth()
  const [nome, setNome] = useState('')
  const [crm, setCrm] = useState('')
  const [especialidades, setEspecialidades] = useState('')
  const [nomeWorkspace, setNomeWorkspace] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (!loading && !user) {
    if (typeof window !== 'undefined') window.location.href = '/login'
    return null
  }
  if (!loading && !allowSelfSignup && !isPlatformAdmin) {
    if (typeof window !== 'undefined') window.location.href = '/login'
    return null
  }
  if (!loading && workspaces.length > 0) {
    if (typeof window !== 'undefined') window.location.href = '/'
    return null
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErro(null)
    if (nome.trim().length < 3) { setErro('Informe seu nome completo.'); return }
    setBusy(true)
    try {
      await criarWorkspace({
        nomeWorkspace: nomeWorkspace.trim() || `Consultório de ${nome.trim().split(' ')[0]}`,
        nomeMedico: nome.trim(),
        crm: crm.trim() || null,
        especialidades: especialidades
          .split(',')
          .map(s => s.trim())
          .filter(Boolean),
      })
      await refresh()
      window.location.href = '/'
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Não foi possível criar o workspace.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="public-screen">
      <div className="card" style={{ width: '100%', maxWidth: 460, padding: '32px 28px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6 }}>
          <div
            aria-hidden
            style={{
              width: 42, height: 42, borderRadius: 12, background: 'var(--primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
            }}
          >
            <Stethoscope size={22} />
          </div>
          <div>
            <h1 style={{ fontSize: 19, fontWeight: 800, margin: 0 }}>Bem-vindo ao Médico 360</h1>
            <p className="page-subtitle" style={{ margin: 0 }}>Vamos montar sua área profissional.</p>
          </div>
        </div>

        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 20 }}>
          <div>
            <label className="field-label" htmlFor="nome">Seu nome completo *</label>
            <input id="nome" className="field-input" required value={nome} onChange={e => setNome(e.target.value)} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label className="field-label" htmlFor="crm">CRM</label>
              <input id="crm" className="field-input" value={crm} onChange={e => setCrm(e.target.value)} placeholder="000000/UF" />
            </div>
            <div>
              <label className="field-label" htmlFor="esp">Especialidades</label>
              <input
                id="esp" className="field-input" value={especialidades}
                onChange={e => setEspecialidades(e.target.value)}
                placeholder="Ex.: Ginecologia, Mastologia"
              />
            </div>
          </div>
          <div>
            <label className="field-label" htmlFor="ws">Nome da sua área de trabalho</label>
            <input
              id="ws" className="field-input" value={nomeWorkspace}
              onChange={e => setNomeWorkspace(e.target.value)}
              placeholder="Ex.: Consultório Dra. Ana"
            />
            <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
              É o espaço que reúne sua carteira de pacientes, agenda e equipe — de todas as clínicas onde você atende.
            </div>
          </div>

          {erro && <div className="field-error" role="alert">{erro}</div>}

          <button type="submit" className="btn-primary" disabled={busy}>
            {busy && <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} aria-hidden />}
            Criar minha área
          </button>
          <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
        </form>
      </div>
    </div>
  )
}
